import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";
import reducers from "./reducers";
import * as services from "./services";

const cookieUser = services.getLoginUser();
const preloadedState = cookieUser?.userId
  ? {
      auth: {
        isAuth: true,
        user: cookieUser,
        loading: false,
        error: null,
        loginLoading: false,
        registerLoading: false,
        creatingUser: false,
        communityBlocked: false,
      },
    }
  : {};

const middleware = [thunk];

const store = createStore(
  reducers,
  preloadedState,
  composeWithDevTools(applyMiddleware(...middleware))
);

export default store;